var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_48_8648",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_48_8648",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACrklEQVR4nO2YW4hNURjHf8SIcglvBkOipJSpiTR5Yp6UKElePHgll2Y0pWaKJpLMg3LJjJSU4glRRFFeiCgU4cUtwzwwbo1ZWvXt6Wu3197ntjtrTftf/05n7bXW/n5ndf577QWFChUqVKhQdTKBe1RjBuSdB8VU6ucaZDZwz4OiyvVtYAYxTQIueFCcKdH9QEMcYod8jgN6PCjSpHgE6FS1t2sQ26EXGC/ftwN/PCjaxPwb2Co1TgBOuFLrCjBF2lYDXzwo3ogHgFapbSpwLSt+nwBzpX0R8NIDiFfAYqmpEXhc6nPkPbBCrs0E7tYR4r6kqlUL8CmhjxPE+juwXiXa+TpAnFPJtBEYcvRLBbEeBnaqROuQ1MgbYAToknta7QL+pfTPBIl8SlLCajPwM+dk2paQTKYWINY3gGnSfxXwOQeIr8AaRzLVDMT6KTBPxiwEXtQQ4jWwROaek5BMNQWJEq1ZJdqdMsY+Am4Bv2LtD4FZKpk+lllTRSDWP4ANMrZB9j2ljHsgYyYDa4GLKiFbM5LJ5AFiJEX2qDk6S0i0YfXLR0kY/ZmHMpLJ5AUS+QwwUebZVMIvukXfWGB6q6xhVKZK3wSmy1wrMxLtutqcapjjPoAY4BnQJPM1ydYi7YmdBHPMBxAj+yC7Ikih64BDwGF5PrSpxEqCsTrqA4j1X+CAJFNctu2S6tvvgDniA0jkb0AfsBvYLyswkNCvzwHT4wtIOXatTHdoIGkr0xUaSBpMR2gglcJ4CWKAsw6Y9tBATArMvtBATArM3tBADHBavbu7VqYtBBAjZwZJMAflut1xLwgBxCTAzAfeqOv2AN5rtQCDUuxJgbEQb2OgHwhAzXLCYuSgMA4RDIjV8oxD9csEpGWOE5ZBdZQUjBrVK4E9fbkKLK13UYXGtP4DevewupwBu88AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c54ef1c0d9ce2e74e43c2ef12d0d1906.svg";
export { ForwardRef as ReactComponent };